import React from 'react';
import PropTypes from 'prop-types';
import { shouldUpdate } from 'recompose';
import { Box } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

const AlertBox = ({ content, onClick, type, innerRef, style }) => {
  const iconsClassMap = {
    error: 'warning',
    information: 'information',
    notification: 'exclamation',
    success: 'check-mark',
  };

  return content.length > 0 ? (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      role="presentation"
      className={`alert-box ${type} ${onClick && 'clickable'}`}
      onClick={onClick}
    >
      <div className="message-box referral-message-box" style={style}>
        <i className={`icon icon-${iconsClassMap[type]}`} />
        {content}
      </div>
      {onClick && (
        <IconButton ref={innerRef} aria-label="Close">
          <DeleteIcon />
        </IconButton>
      )}
    </Box>
  ) : null;
};

const checkPropsChange = (props, nextProps) => props.content !== nextProps.content || props.type !== nextProps.type;

AlertBox.defaultProps = {
  onClick: null,
  content: '',
  innerRef: () => {},
};

AlertBox.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string.isRequired,
  innerRef: PropTypes.func,
};

export default shouldUpdate(checkPropsChange)(AlertBox);
